import { EntityPointer, Feature, Types } from '.';
import { OmniChatSchema } from '@omnichat/omnichat-model';
export interface DashboardDataNormalized {
  topHeader: DashboardCardData[];
  dataColumns: Array< string | EntityPointer >;
  data: DashboardCardData[];
  totalCount?: number;
}

export interface DashboardResponse {
  topHeader?: DashboardCardData[];
  dataColumns: Array< string | EntityPointer >;
  data: DashboardCardData[][];
  count?: number;
}

export interface DashboardQuery {
  dateStart: string;
  dateEnd: string;
  type: OmniChatSchema.Feature;
  granularity: number;
  teamId: string;
  page?: number;
  pageSize?: number;
}

export interface DashboardCardColumn {
  name: string;
  orderable?: boolean;
  unit: DashboardCardUnit;
}

export interface DashboardCardData {
  label?: string | any;
  entity?: EntityPointer;
  icon?: string;
  iconColor?: string;
  iconSrc?: string;
  unit?: DashboardCardUnit;
  value: number[] | string | number;
  valuePast?: number[] | string | number;
  percent?: number;
  onClick?: (item: any) => void;
}

export enum DashboardCardType {
  TABLE = 'TABLE',
  TABLE_WITH_HEADER = 'TABLE_WITH_HEADER',
  CHART = 'CHART',
}

export enum DashboardCardUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  NUMBER = 'NUMBER',
  PERCENT = 'PERCENT',
  CURRENCY = 'CURRENCY',
}

export interface NormalizeOptions {
  data?: {
    unit?: DashboardCardUnit,
  };
  topHeader?: Array<{ icon?: string, iconSrc?: string, iconColor?: string, unit?: DashboardCardUnit }>;
}
